import { createClient } from "@supabase/supabase-js";
import { Col, Layout, message, Row, Spin } from "antd";
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { getSupaClient } from "../../lib/supabase";
import DotsFishLoading from "../DotsFishLoading/DotsFishLoading";

const queryString = require("query-string");

const { Content } = Layout;

const SlackReAuthorized = (props) => {
  const supabase = getSupaClient();
  const navigate = useNavigate();
  const location = useLocation();
  const slackCode = queryString.parse(location.search).code;

  const handleRedirect = async () => {
    const response = await fetch(`${process.env.REACT_APP_API}/addtoslack`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        slackCode,
        reactAppURI: `${process.env.REACT_APP_URI}/auth/reauthorized/`,
        supaUser: supabase.auth.user(),
      }),
    });

    const token = await response.json();
    if (token.data) {
      message.success("Successfully reauthorized Slack!");
      localStorage.removeItem("teams");
      window.analytics.track("Slack Reauthorized");
    } else {
      message.error("Error reauthorizing Slack.");
      window.analytics.track("Error reauthorizing Slack");
    }
    return navigate("/settings");
  };
  // load once
  useEffect(() => {
    handleRedirect();
  }, []);

  return (
    <Content align="middle" style={{ minHeight: "100vh" }}>
      <Row
        type="flex"
        justify="center"
        align="middle"
        style={{ minHeight: "100vh" }}
      >
        <Col span={12}>
          <img alt="Add to slack" src="/teaching.png" width="300" />
          <h2>Reauthorizing!</h2>
          <DotsFishLoading />
        </Col>
      </Row>
    </Content>
  );
};

export default SlackReAuthorized;
